module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.output),
      expression: "output"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": _vm.rows
    },
    domProps: {
      "value": (_vm.output)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.output = $event.target.value
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-894a67fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/AutoTextArea.vue
// module id = 473
// module chunks = 1